import React from 'react';

import "./InputGroup.scss"

function InputGroup() {

    return (
        <div className="InputGroup">
            <h3 className="Header">Shock Vectors</h3>
            <div className="InputList" data-bind="foreach: iv_disp">
                <div className="Shock">
                    {/* <label class="Header" data-bind="text: region+'.' + sector, attr:{for: 'svv' + $index()}" /> */} 
                    <label className="Label" data-bind="text: '[' + region + ']' + ' ' + sector, attr:{for: 'svv' + $index()}"/>
                    <input className="Input" type="text" autoComplete="off"
                    data-bind="value:$root.mrsam_shock_vec[region][sector],
                                attr: {id: 'svv' + $index(), name: 'svv' + $index() },
                                css: { inError: $root.mrsam_shock_vec[region][sector].hasError }" />
                </div>
            </div>
        </div>
    );
}

export default InputGroup;